import React from 'react';
import styles from './TrophyPageHeader.scss';
import InternetPoints from '../InternetPoints';
import RadioFilterGroup from '../RadioFilterGroup';
import BackToProfile from '../BackToProfile';
import { withTranslation } from '../../i18n';

function TrophyPageHeader({
  username,
  displayName,
  points,
  trophyCount,
  trophyFilter,
  handleTrophyFilterChange,
  t,
}) {
  const filters = [
    {
      value: 'all',
      label: t('all'),
      name: 'all',
      checked: trophyFilter === 'all',
    },
    {
      value: 'earned',
      label: t('earned'),
      name: 'earned',
      checked: trophyFilter === 'earned',
    },
    {
      value: 'unearned',
      label: t('unearned'),
      name: 'unearned',
      checked: trophyFilter === 'unearned',
    },
  ];

  return (
    <header className={styles.header}>
      <BackToProfile username={username} />
      <h1 className={styles.displayName}>{displayName}</h1>
      <div className={styles.headerBar}>
        <InternetPoints internetPoints={points} />
        <p>
          <span className={styles.trophyCount}>{trophyCount}</span>{' '}
          {t('trophies')}
        </p>
      </div>
      <RadioFilterGroup
        label={t('order_by')}
        name="trophy-filter"
        options={filters}
        containerClassName={styles.filterContainer}
        onChange={handleTrophyFilterChange}
      />
    </header>
  );
}

export default withTranslation('common')(TrophyPageHeader);
